// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2lDdc","footer":"ModalCreateQualiphyProcedure_footer__2WktR","additionData":"ModalCreateQualiphyProcedure_additionData__2zUIR"};